import {
  type LoyaltyTierPrize,
  Prize,
  StockStrategy
} from "kadow-jetpack-model";
import { DEFAULT_PRIZE_EXPIRY } from "../constants";
import TSUtils from "./TSUtils";
import type ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import { tt } from "../i18n/i18n";

const BASE_GIFT: Prize = {
  id: "",
  name: "",
  longName: "",
  description: "",
  image: "🎁",
  pc: 0,
  conditions: [],
  isVoucher: false,
  unBlurDelay: 1,
  ss: StockStrategy.None,
  expiry: {
    method: "none",
    value: 0
  }
};

export function buildBaseGift(
  accountToDisplay: ManagedAccount | undefined | null
) {
  return enrichGiftWithAdvancedCouponFeatures(accountToDisplay, BASE_GIFT);
}

export function enrichGiftWithAdvancedCouponFeatures(
  accountToDisplay: ManagedAccount | undefined | null,
  baseGift: Prize | LoyaltyTierPrize
) {
  if (!accountToDisplay?.saasFeatures?.adc) {
    return {
      ...baseGift,
      id: baseGift.id ?? TSUtils.generateRandomString(5)
    };
  }

  const conditions: string[] = [];

  if (accountToDisplay) {
    const redemptionCondition = tt("default_redeem_condition");
    conditions.push(redemptionCondition);
  }

  return {
    ...baseGift,
    id: baseGift.id ?? TSUtils.generateRandomString(5),
    unBlurDelay: -1,
    conditions,
    expiry: { ...DEFAULT_PRIZE_EXPIRY }
  };
}
